<template>
  <div class="internet-info" :class="{ white: isReverse }">
    <div
      class="item"
      v-if="item.promotionId > 0"
      v-html="_toBR(item.item.replace('[TV]', '<br />[TV]'))"
    ></div>
    <div class="item" v-else v-html="itemList(item)"></div>
    <hr class="line" :class="{ grey: isReverse }" />
    <div class="txt-box">
      <div class="ttl">
        <p>통신사</p>
        <p>월 요금</p>
        <p v-if="isPromotionView">총 혜택</p>
        <p v-else>지원금</p>
      </div>
      <div class="txt">
        <p class="telecom">{{ item.telecom }}</p>
        <p>{{ item.monthPrice | comma }}원</p>
        <p class="red" v-if="item.promotionId > 0">
          {{
            (item.cashSupport +
              item.giftCardSupport +
              item.giftItemSupport +
              item.perceSupport)
              | comma
          }}원
        </p>
        <p class="red" v-else-if="isPromotionView">
          {{ getTotalPrice(item) | comma }}원
        </p>
        <p class="red" v-else>
          {{
            (item.cashSupport + item.giftCardSupport + item.giftItemSupport)
              | comma
          }}원
        </p>
      </div>
    </div>
    <div v-if="item.promotionId > 0" class="desc">
      매장지원 {{ getNumberToKorean(item.cashSupport) }}원

      <span class="bk" v-if="item.giftCardSupport > 0">
        (상품권{{ getNumberToKorean(item.giftCardSupport) }}원 포함)
      </span>
      + 퍼스지원
      {{ getNumberToKorean(item.perceSupport) }}원
    </div>
    <div v-else-if="isPromotionView" class="desc">
      요금할인(퍼스특별) {{ getPromotionSupportPrice(item) | comma }}원 + 상품권
      {{ getPromotionGiftPrice(item) | comma }}원
    </div>
    <div v-else>
      <div
        class="desc"
        v-if="
          item.cashSupport > 0 ||
            item.giftCardSupport > 0 ||
            item.giftItemSupport > 0
        "
      >
        (
        <span v-if="item.cashSupport > 0"
          >{{ item.cashSupport | comma }}원 현금
          <span v-if="item.giftCardSupport == 0 && item.giftItemSupport == 0"
            >지원</span
          >
        </span>
        <span v-if="item.giftCardSupport > 0">
          <span v-if="item.cashSupport > 0"> + </span>
          {{ item.giftCardSupport | comma }}원 상품권
          <span v-if="item.giftItemSupport == 0">지원</span>
        </span>
        <span v-if="item.giftItemSupport > 0">
          <span v-if="item.cashSupport > 0 || item.giftCardSupport > 0">
            + </span
          >{{ item.giftItemSupport | comma }}원 사은품
          <span>지원</span>
        </span>
        )
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  name: 'component-internet-detail-info',
  description: '인터넷 상세 정보 컴포넌트',
  props: {
    item: Object,
    isReverse: {
      type: Boolean,
      default: false,
      description: 'default background color is grey color',
    },
    isPromotionView: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  methods: {
    _toBR(str) {
      console.log('itemitemitemitem');
      console.log(this.item);
      var st = `<p class="ct">${str}</p>`;
      return util.toBR(st);
    },
    itemList(item) {
      console.log('itemitemitemitem2222');
      console.log(item);

      let data = '';

      if (item.itemInternet != '' && item.itemInternet != undefined) {
        if (item.itemSpeed) {
          data = `[${item.itemSpeed} 인터넷] ${item.itemInternet}`;
        } else {
          let itemSpeed = item.item.split(' ');
          itemSpeed = itemSpeed[0];

          data = `[${itemSpeed} 인터넷] ${item.itemInternet}`;
        }
        if (item.itemTv != '' && item.itemTv != undefined) {
          data += `<br />`;
          data += `[TV] ${item.itemTv}`;
        }
      } else {
        const itemArr = item.item.split('+');

        if (item.phoneTogether == 'PHONE') {
          var ph = item.phoneTogether == 'PHONE' ? ' 휴대폰 동시구매' : '';
          itemArr.push(ph);
        }

        itemArr.forEach((it, index) => {
          if (it === '') return;
          if (itemArr.length === 1 || itemArr.length === index + 1) {
            data += `<p>${it}</p>`;
          } else {
            data += `<p>${it}&nbsp;|</p>&nbsp;`;
          }
        });
      }
      return data;
    },
    getNumberToKorean(number) {
      return util.numberToKorean(number);
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(item.telecom, telecomItem);

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    getPromotionSupportPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthSupportPrice(item.telecom, telecomItem);
    },
    getPromotionGiftPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthGiftPrice(item.telecom, telecomItem);
    },
    getPromotionItem(item) {
      let itemArr = '';
      let telecomItem = '';
      if (item.item == '100M 인터넷') {
        itemArr = item.item.split(' ');
        telecomItem = itemArr[0];
      } else {
        itemArr = item.item.split('+');
        if (itemArr[0].indexOf('100M') != -1) {
          telecomItem = '100M';
        } else if (itemArr[0].indexOf('500M') != -1) {
          telecomItem = '500M';
        }

        if (itemArr[1].indexOf('TV') != -1) {
          telecomItem += '+TV';
        }
      }
      return telecomItem;
    },
  },
};
</script>

<style></style>
